import { render, staticRenderFns } from "./SessionTimeout.vue?vue&type=template&id=1a64ac4b&"
import script from "./SessionTimeout.vue?vue&type=script&lang=js&"
export * from "./SessionTimeout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports